/* @flow */
import React from 'react';
import { isEqual } from 'lodash';

import Group from 'entities/Group';
import GroupMessages from 'groups/components/GroupMessages.jsx';
import { markChange } from 'lib/Timer';
import { promiseGroupOrRootChats } from 'chat/utils/ChatPromises';

import type { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

class GroupMessagesContainer extends React.Component {
  static propTypes = {
    params: React.PropTypes.object.isRequired,
    children: React.PropTypes.node,
    // group this is always provided, but cannot be required because of some shit with either react-router or AsyncProps
    group: React.PropTypes.instanceOf(Group),
  };

  static onEnter(nextState: RouterState, replaceWith: (location: LocationDescriptor) => void, callback: Function) {
    const { groupCode } = nextState.params;
    promiseGroupOrRootChats(groupCode).then(() => {
      return callback();
    }).catch(e => console.error('GroupMessagesContainer promiseGroupOrRootChats failed', e));
  }

  componentDidMount() {
    markChange('to_chats', 'mounted');
  }

  shouldComponentUpdate(nextProps: Object) {
    const groupChanged = !isEqual(this.props.group.attributes, nextProps.group.attributes);
    const routeChanged = !isEqual(this.props.params, nextProps.params);
    return routeChanged || groupChanged;
  }

  render() {
    const { group, children, params } = this.props;

    return (
      <GroupMessages group={group} selectedChatId={params.chatId}>
        {React.cloneElement(children, { group })}
      </GroupMessages>
    );
  }
}

export default GroupMessagesContainer;



// WEBPACK FOOTER //
// ./src/groups/containers/GroupMessagesContainer.jsx